import axiosInstance from "./axiosInstance";

// Tokens stay in memory and are sent only to the current Unity frame's exact origin.
export async function sendUnitySession(frame) {
  if (!frame?.contentWindow) return;
  const target = frame.contentWindow;
  const origin = new URL(frame.src).origin;
  const meetingID = sessionStorage.getItem("meetingID");
  if (!meetingID) return;
  try {
    const { data } = await axiosInstance.post("/api/unity-session", { meetingID, demoBuild: meetingID.startsWith("demo-") });
    if (!frame.isConnected || frame.contentWindow !== target || new URL(frame.src).origin !== origin
        || sessionStorage.getItem("meetingID") !== meetingID) return;
    target.postMessage(JSON.stringify(data), origin);
  } catch {
    // Never log the response or token. Authentication failures use the normal login flow.
    console.error("Unable to authorize Unity session");
  }
}
